import React, { useContext, useState } from 'react'
import { WhyLHRIdeal, HowLHRWorks, LHRBenefits, WhatCustomersSay, LPCredit, LpHero, LPUnlimitedPackage, SignUpModal, SEO, LocationsBanner, SayHelloTo } from '../../components'
import { GlobalSiteDataContext } from "../../context"
import { graphql } from 'gatsby'
import './lp.css'

function LpPage() {
  const siteData = useContext(GlobalSiteDataContext)
  const [showSignUpModal, setShowSignUpModal] = useState(false)
  return (
    <main id="lp-page">
      <LpHero />
      <HowLHRWorks />
      {/* <HRTurqLight /> */}
      <WhyLHRIdeal />
      <SayHelloTo />
      <LHRBenefits />
      {showSignUpModal && <SignUpModal {...{ siteData, showSignUpModal, setShowSignUpModal }} />}
      <LPUnlimitedPackage setShowSignUpModal={setShowSignUpModal} />
      <LocationsBanner siteData={siteData} />
      <LPCredit globalData={siteData.globalData} />
      <WhatCustomersSay />
    </main>
  )
}

export const Head = ({ data, location }) => {
  const query = data.siteDataJson
  return (
    <SEO
      location={location} origin={query.origin}
      title={`Experts in Laser Hair Removal | Milan Laser | Location: ${query.name}, ${query.stateAbbrev}`}
      description="Learn about waxing vs laser hair removal cost, pain, history and more." />
  )
}

export const query = graphql`
{
  siteDataJson {
    name
    stateAbbrev
    origin
  }
}
`

export default LpPage
